var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumanlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 110,
    viewBox: "0 0 70 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.8427,
    cy: 10.5068,
    rx: 9.98142,
    ry: 10.5068,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1002 66.4287H31.1647V105.564L31.5016 106.239C32.8493 108.432 34.1969 109.444 37.3976 109.106C39.9582 108.836 40.9353 107.082 41.1037 106.239V101.619V78.6477V36.9086L46.8313 47.5358C48.4485 50.6397 51.2112 51.3032 52.3904 51.2469L65.1932 50.4035C66.8104 50.1336 67.8885 49.2789 68.2254 48.8853C69.7079 47.4009 69.4046 45.118 69.0677 44.1621C68.3939 41.5981 64.9686 41.2944 63.3401 41.4631L54.2434 42.1379L48.0105 30.3298C47.3367 29.149 45.7868 26.3488 44.9782 24.5945C44.1696 22.8401 41.2836 22.1766 39.9417 22.0642H22.068H16.172C13.6114 22.0642 12.2974 23.4137 11.9605 24.0884L8.08598 31.0046L3.36916 39.9449L1.85304 42.8126C1.04444 43.8922 0.505373 45.5116 0.336916 46.1863L0 56.4762V59.6812C0 60.6259 0.22461 61.4243 0.336916 61.7055C0.875981 63.055 2.2461 63.8422 2.86378 64.0671C3.64992 64.4045 5.5928 64.7756 7.07523 63.561C8.55766 62.3465 9.04057 60.4684 9.09672 59.6812L9.43364 48.0419L15.1612 37.4146V61.5368V74.0196V100.503L15.3297 104.214C15.3297 106.778 17.0142 108.319 17.8565 108.769C18.3619 109.106 19.9117 109.612 22.068 108.938C24.2242 108.263 24.9879 105.508 25.1002 104.214V88.1384V66.4287Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanlogo);
export default __webpack_public_path__ + "static/media/humanlogo.919dcdd0a014a8296432ada2646e34f5.svg";
export { ForwardRef as ReactComponent };